module.exports = "<!-- NOT USED -->\n\n<!-- <div class=\"sn-oomph\">\n  <oom-header></oom-header>\n  \n  <div #oomph_view></div>\n\n  <oom-footer></oom-footer>\n </div>   -->"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oomph.component.html
// module id = ../../../../../src/app/components/oomph/oomph.component.html
// module chunks = main